import { render, staticRenderFns } from "./ChoiceWord.vue?vue&type=template&id=7987c07a&scoped=true"
import script from "./ChoiceWord.vue?vue&type=script&lang=js"
export * from "./ChoiceWord.vue?vue&type=script&lang=js"
import style0 from "./ChoiceWord.vue?vue&type=style&index=0&id=7987c07a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987c07a",
  null
  
)

export default component.exports